import Button from '@mui/joy/Button'
import Redo from '@mui/icons-material/Redo'

export const RedoButton = ({ onClick, disabled }) => (
    <Button
        variant="outlined"
        color="primary"
        onClick={onClick}
        disabled={disabled}
        endDecorator={<Redo />}
    >
        Redo
    </Button>
)
